// Qo'ng'iroqdan keyingi izohni tegishli `call_records` yozuviga biriktirish.
//
// Muammo: yozuvni backenddagi cdrSync qo'ng'iroq TUGAGANDAN keyin (har 5 s)
// yaratadi, operator esa izohni darhol yozib "Saqlash"ni bosishi mumkin — u
// paytda yozuv hali yo'q. Shuning uchun izoh navbatga qo'yiladi va yozuv
// paydo bo'lguncha qayta uriniladi. Navbat localStorage'da — sahifa yangilansa
// ham yozilgan izoh yo'qolmaydi.
//
// Qaysi yozuv? Qo'ng'iroqqa javob berilgan paytda shu raqamdagi MAVJUD yozuvlar
// eslab qolinadi (snapshotKnownIds); keyin paydo bo'lgan yangi yozuv aynan shu
// qo'ng'iroq. Vaqt bo'yicha solishtirilmaydi: operator kompyuteri soati server
// soatidan farq qilishi mumkin, raqam qayta terilganda esa oldingi qo'ng'iroq
// yozuvi bilan adashtirish xavfi bor.
import { callsAPI } from './api';

const STORE_KEY = 'cc_pending_call_notes';
export const RETRY_MS = 4000;
export const GIVE_UP_MS = 3 * 60 * 1000;     // yozuv 3 daqiqada topilmasa — to'xtaymiz
const MAX_AGE_MS = 2 * 60 * 60 * 1000;       // sahifa qayta ochilganda eski navbat tashlanadi
const FALLBACK_WINDOW_MS = 15 * 60 * 1000;   // snapshot olinmagan bo'lsa — faqat yaqin yozuvlar

// Raqam formati farq qilishi mumkin (+998…, bo'sh joy) — oxirgi 9 raqam bo'yicha
// qidiramiz. Haqiqiy ma'lumotda tekshirilgan (2026-09-16): 14 kunda brauzer ko'rgan
// 493 qo'ng'iroqning hammasi shu kalit bilan o'z yozuvini topgan.
export function searchKey(number) {
  const d = String(number || '').replace(/\D/g, '');
  return d.length > 9 ? d.slice(-9) : d;
}

async function listByNumber(number) {
  const key = searchKey(number);
  if (key.length < 3) return [];
  const res = await callsAPI.list({ search: key, limit: 30 });
  return (res.data && res.data.calls) || [];
}

export async function snapshotKnownIds(number) {
  return (await listByNumber(number)).map((c) => c.id);
}

// Ro'yxat call_date bo'yicha kamayish tartibida keladi (birinchisi — eng yangisi).
export function pickRecord(calls, item, now = Date.now()) {
  const known = Array.isArray(item.knownIds) ? new Set(item.knownIds) : null;
  const isNew = (c) => (known
    ? !known.has(c.id)
    : now - new Date(c.call_date).getTime() < FALLBACK_WINDOW_MS);
  // Operator faqat O'Z yozuviga izoh yoza oladi (backend 403). Kiruvchida operator
  // yozuvga biroz keyin biriktiriladi — shungacha egasiz yozuvni tanlamaymiz, kutamiz.
  const isMine = (c) => item.role !== 'operator' || c.operator_id === item.userId;
  const cands = calls.filter((c) => c.direction === item.direction && isNew(c) && isMine(c));
  if (cands.length <= 1) return cands[0] || null;
  // Bir nechta yangi yozuv (raqam ketma-ket qayta terilgan) — davomiyligi eng yaqini.
  const dur = Number(item.durationSec) || 0;
  return cands.reduce((best, c) => (
    Math.abs((c.billable_sec || 0) - dur) < Math.abs((best.billable_sec || 0) - dur) ? c : best
  ));
}

// true — saqlandi; false — hali tayyor emas (yozuv yo'q yoki operator biriktirilmagan).
export async function attemptSave(item) {
  const rec = pickRecord(await listByNumber(item.number), item);
  if (!rec) return false;
  const existing = (rec.notes || '').trim();
  if (existing.includes(item.text)) return true; // oldingi urinish saqlagan, javobi yo'qolgan
  const notes = existing ? `${existing}\n${item.text}` : item.text;
  try {
    await callsAPI.updateNotes(rec.id, notes);
    return true;
  } catch (e) {
    const status = e.response && e.response.status;
    if (status === 403 || status === 404) return false;
    throw e;
  }
}

function load() {
  try {
    const v = JSON.parse(localStorage.getItem(STORE_KEY) || '[]');
    return Array.isArray(v) ? v : [];
  } catch (e) {
    return [];
  }
}

function store(list) {
  try { localStorage.setItem(STORE_KEY, JSON.stringify(list)); } catch (e) {}
}

function removeItem(id) {
  store(load().filter((x) => x.id !== id));
}

const running = new Set();

function run(item, { onSaved, onFailed } = {}) {
  if (running.has(item.id)) return;
  running.add(item.id);
  const startedAt = Date.now();
  const tick = async () => {
    let done = false;
    try { done = await attemptSave(item); } catch (e) { /* tarmoq xatosi — keyingi urinishda */ }
    if (done || Date.now() - startedAt >= GIVE_UP_MS) {
      running.delete(item.id);
      removeItem(item.id);
      if (done) { if (onSaved) onSaved(item); } else if (onFailed) onFailed(item);
      return;
    }
    setTimeout(tick, RETRY_MS);
  };
  tick();
}

// data: { userId, role, number, direction, durationSec, knownIds, text }
export function queueCallNote(data, handlers) {
  const item = { id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, createdAt: Date.now(), ...data };
  store([...load(), item]);
  run(item, handlers);
  return item;
}

// Sahifa yangilanganda tugamay qolgan izohlarni davom ettiradi (faqat shu foydalanuvchiniki).
export function resumePendingCallNotes(userId, handlers) {
  const now = Date.now();
  const list = load();
  const fresh = list.filter((x) => now - x.createdAt < MAX_AGE_MS);
  if (fresh.length !== list.length) store(fresh);
  fresh.filter((x) => x.userId === userId).forEach((x) => run(x, handlers));
}
